// components/RoutePermissionGate.tsx
import React from "react";
import { usePermissions } from "../hooks/usePermissions";
import { useLocation } from "react-router-dom";
import { queryClient } from "@shared/api/queries/queryClient";

interface RoutePermissionGateProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  loadingComponent?: React.ReactNode; // optional custom loader
}

export const RoutePermissionGate: React.FC<RoutePermissionGateProps> = ({
  children,
  fallback,
  loadingComponent,
}) => {
  const { hasCurrentRouteAccess, isLoading, error } = usePermissions();
  const location = useLocation();

  console.log("RoutePermissionGate state:", {
    isLoading,
    hasAccess: hasCurrentRouteAccess(),
    pathname: location.pathname,
  });

  // ✅ Handle loading state
  if (isLoading) {
    return (
      loadingComponent || (
        <div className="flex flex-col items-center justify-center h-64 space-y-4">
          <p className="text-gray-500">Loading...</p>
        </div>
      )
    );
  }

  // Show error state if permissions failed to load
  // if (error) {
  //   window.location.reload();
  //   return null; // important to stop render after reload
  // }

  if (error) {
    console.log("errpr", error);
  }

  if (!hasCurrentRouteAccess()) {
    return (
      <div className="flex flex-col items-center justify-center h-64 space-y-4">
        <h2 className="text-xl font-semibold text-gray-700">Access Denied</h2>
        <p className="text-gray-500">
          You don't have permission to access this page.
        </p>
      </div>
    );
  }

  return <>{children}</>;
};
